import { HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

import host from '@/consts/host';

export const httpLink = new HttpLink({
  uri: host,
  credentials: 'same-origin',
});

/**
 * Replace default `httpLink` terminating link with `uploadLink` (apollo-upload-client) to support file uploads
 */
export const uploadLink = createUploadLink({
  uri: host,
  credentials: 'same-origin',
});

export const createAuthLink = (backendToken?: string) => {
  return setContext(async (_, { headers }) => {
    const authHeader = backendToken ? `JWT ${backendToken}` : '';

    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Authorization: authHeader,
      },
    };
  });
};

export const removeTypenameLink = removeTypenameFromVariables();
